<div>
  <button *ngIf="hasPermissions('manage_companies')" style="margin: 15px" class="floatR marginB" nz-button nzType="primary" nzShape="circle" (click)="showModal(false)">
    <span nz-icon nzType="plus" nzTheme="outline"></span>
  </button>

  <div style="padding: 20px">
    <nz-input-group nzPrefixIcon="search">
      <input style="padding: 10px" (keyup)="search($event)" type="text" nz-input placeholder="Search by Company, Phone or Distributor" />
    </nz-input-group>
  </div>

  <div>
    <nz-table #companyTable [nzLoading]="loading" [nzData]="companiesList" nzShowSizeChanger>
      <thead>
        <tr>
          <th>Company</th>
          <th>Phone</th>
          <th>Distributor</th>
          <th *ngIf="hasPermissions('manage_companies')"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of companyTable.data">
          <td>{{ c.name }}</td>
          <td>{{ c.phone }}</td>
          <td>{{ c.distributor }}</td>
          <td *ngIf="hasPermissions('manage_companies')">
            <button (click)="showModal(c)" nz-button nzType="primary" nzShape="circle">
              <span nz-icon nzType="edit" nzTheme="outline"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

</div>

<nz-modal [(nzVisible)]="isModalVisible" nzTitle="Company" nzCentered (nzOnCancel)="cancelAddEdit()" (nzOnOk)="confirmAddEdit()">
  <ng-container *nzModalContent>
    <form [formGroup]="companyForm">
      <nz-form-item>
        <nz-form-label nzRequired>Name</nz-form-label>
        <input nz-input formControlName="name" />
      </nz-form-item>

      <nz-form-item>
          <nz-form-label nzRequired>Phone</nz-form-label>
          <input nz-input mask="(000) 000-0000"  formControlName="phone" />
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Distributor</nz-form-label>
        <nz-select [nzDisabled]="!currentUser?.super_admin" nzPlaceHolder="Select a Distributor" formControlName="distributor_id" style="width: 100%;" (ngModelChange)="distributorChanged($event)">
          <nz-option *ngFor="let d of distributors" [nzLabel]="d.name" [nzValue]="d.id"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Providers</nz-form-label>
        <nz-select [nzLoading]="providersLoading" nzMode="multiple" nzPlaceHolder="Select providers" formControlName="providers" style="width: 100%;">
          <nz-option *ngFor="let p of providers" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Leaderboard Default Provider</nz-form-label>
        <nz-select [nzLoading]="providersLoading" nzPlaceHolder="Select providers" formControlName="leaderboard_preference" style="width: 100%;">
          <nz-option nzLabel="All" [nzValue]="null"></nz-option>
          <nz-option *ngFor="let p of providers" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
        </nz-select>
      </nz-form-item>

    </form>
  </ng-container>
</nz-modal>
